import React, { useState } from 'react';
import { StyledModal } from './style';
import { Button, Result } from 'antd';
import Lottie from "lottie-react";
import {pendingAnimation} from "bukku/components/Lottie/pendingAnimation";
import {successAnimation} from "bukku/components/Lottie/successAnimation";
import {failAnimation} from "bukku/components/Lottie/failAnimation";
import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
// import { readStorage } from '../../../../../redux/LocalStorage/helpers/readStorage';
// import { writeStorage } from '../../../../../redux/LocalStorage/helpers/writeStorage';
import dayjs from 'dayjs';
import { usePrevious } from '../../../../../helpers/useReadStateSuccess';
import { useSelector } from 'react-redux';
import { pendingDocAnimation } from './pendingDocAnimation';
import { noConsentAnimation } from './noConsentAnimation';
import { useEffectSuccess } from '../../../../../components/Providers/helpers/useCompare';
import {isEmpty} from "lodash";

export const FinancingResultType = {
    PREAPPROVED: 'PREAPPROVED',
    NOT_QUALIFIED: 'NOT_QUALIFIED',
    INSUFFICIENT_DATA: 'INSUFFICIENT_DATA', // for Not qualified for Preapproval || Qualified but required for industry information
    SCREENING_FAILED: 'SCREENING_FAILED', //  6 months sales figures didn’t meet minimum,  FS will request for more documents

    // used in frontend only
    consent_denied: 'consent_denied',
    pending_approval: 'pending_approval',
};

export default function FinancingResultModal() {
    useLingui();
    const [isPendingApprovalModalVisible, setPendingApprovalModalVisible] = useState(false);
    const [modalType, setModalType] = useState(null);

    const financingDashboard = useSelector(state => state.Financing.financingDashboard);
    const financingDashboardReadState = useSelector(state => state.Financing.financingDashboardReadState);
    const financingSettingUpdateState = useSelector(state => state.Financing.financingSettingUpdateState);
    // const user = useSelector(state => state.Auth.user);

    const {
        consented_at,
        consent_level,
        loans,
    } = financingDashboard;

    const hasConsent = consented_at && consent_level === 1;
    const prevConsentedAt = usePrevious(consented_at);

    // useEffect(() => {
    //     if (hasConsent && loans.length !== 0) {
    //         const storageData = readStorage('financing_result_modal') || {};
    //         const noLocalStorage = !storageData[user.id]; // will happen if user first time goes into financing portal page, or user clears local storage

    //         const {
    //             result,
    //             // updated_at,
    //         } = loans[0];
    //         const {
    //             updated_at: resultUpdatedAt,
    //         } = result || {};

    //         // - !result: If has consent but no result, means it's within first-time pending pre-approval period.
    //         // - !storageData[user.id]: If local storage doesn't have the modal-shown-date stored.
    //         // - forceShowModal: is true whenever user updates settings consent_level from 0 to 1
    //         if (!result && (forceShowModal || noLocalStorage)) {
    //             setModalType(FinancingResultType.pending_approval);
    //             setPendingApprovalModalVisible(true);
    //         }
    //         // If has consent, and has result, means its eligible/ineligible/ not first time pending pre-approval period
    //         else if (result) {
    //             const {
    //                 status,
    //                 expires_at,
    //             } = result;

    //             // If updated_at is later than storage data, means there's new result, and we should show modal.
    //             const hasNewUpdatedResult = storageData[user.id] &&
    //                 dayjs(storageData[user.id]).isBefore(dayjs(resultUpdatedAt));

    //             // If today is past the previous result's expires_at, AND
    //             // either:
    //             //      - is forceShowModal (happens whenever user updates settings consent_level from 0 to 1), OR
    //             //      - no local storage detected OR
    //             //      - has local storage, and local storage data (which is previous modal prompted date) is before expires_at,
    //             // we prompt the modal. As this period is considered user's 2nd++ pending preapproval period.
    //             const isPreviousOfferExpired =
    //                 dayjs().isAfter(dayjs(expires_at)) &&
    //                 (
    //                     noLocalStorage || forceShowModal ||
    //                     (storageData[user.id] && dayjs(storageData[user.id]).isBefore(expires_at))
    //                 );

    //             if (noLocalStorage || hasNewUpdatedResult || forceShowModal || isPreviousOfferExpired) {
    //                 if (isPreviousOfferExpired)
    //                     setModalType(FinancingResultType.pending_approval);

    //                 else
    //                     setModalType(status);

    //                 setPendingApprovalModalVisible(true);
    //             }
    //         }
    //     }
    //     // user first time give consent, show modal
    //     else if (!prevConsentedAt && hasConsent) {
    //         setModalType(FinancingResultType.pending_approval);
    //         setPendingApprovalModalVisible(true);
    //     }
    // }, [loans, hasConsent, user, forceShowModal, prevConsentedAt]);

    const openModalCheckFn = () => {
        const isFirstTime = !consented_at;
        if (!isFirstTime) {
            // // 1. NO CONSENT GIVEN
            // if (!hasConsent) {
            //     setModalType(FinancingResultType.consent_denied);
            //     setPendingApprovalModalVisible(true);
            // }
            // 2. HAS CONSENT GIVEN
            if (hasConsent && loans.length !== 0) {
                // const storageData = readStorage('financing_result_modal') || {};
                // const noLocalStorage = !storageData[user.id]; // will happen if user first time goes into financing portal page, or user clears local storage

                // The ID for the FS loan in Production is always 1.
                const loan = loans.find(loan => loan.id === 1);
                if (isEmpty(loan))
                    return;

                const {
                    result,
                    // updated_at,
                } = loan;

                // const {
                //     updated_at: resultUpdatedAt,
                // } = result || {};

                // - !result: If has consent but no result, means it's within first-time pending pre-approval period.
                if (!result) {
                    setModalType(FinancingResultType.pending_approval);
                    setPendingApprovalModalVisible(true);
                }
                // If has consent, and has result, means its eligible/ineligible/pending_doc, not first time pending pre-approval period
                else {
                    const {
                        status,
                        expires_at,
                    } = result;

                    // // If updated_at is later than storage data, means there's new result, and we should show modal.
                    // const hasNewUpdatedResult = storageData[user.id] &&
                    //         dayjs(storageData[user.id]).isBefore(dayjs(resultUpdatedAt));

                    // If today is past the previous result's expires_at
                    const isPreviousOfferExpired = dayjs().isAfter(dayjs(expires_at));

                    if (isPreviousOfferExpired)
                        setModalType(FinancingResultType.pending_approval);
                    else
                        setModalType(status);

                    setPendingApprovalModalVisible(true);
                }
            }
            // 3. user first time give/deny consent, show modal
            else if (!prevConsentedAt && hasConsent) {
                setModalType(FinancingResultType.pending_approval);
                setPendingApprovalModalVisible(true);
            }
        }
    };
    useEffectSuccess(financingDashboardReadState, openModalCheckFn);
    useEffectSuccess(financingSettingUpdateState, openModalCheckFn);

    const onCancel = () => {
        setPendingApprovalModalVisible(false);

        // // on modal close, store the time into local storage
        // const storageData = readStorage('financing_result_modal') || {};

        // writeStorage('financing_result_modal', {
        //     ...storageData,
        //     [user.id]: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        // });
    };

    let title, subtitle, icon;
    switch (modalType) {
        case FinancingResultType.consent_denied:
            icon = <Lottie
                animationData={noConsentAnimation}
                style={{width: 240}}
                className="margin-vertical-negative-24"
            />;
            title = <Trans>No Consent Given</Trans>;
            subtitle = (
                <p>
                    <Trans>
                        Your data will not be shared with our lending partners.
                        However, you may still browse the list of providers and apply
                        for a loan using the standard process.&nbsp;
                        <a href="https://intercom.help/bukku/en/articles/8937350-introducing-financing-portal" target="_blank" rel="noreferrer">Learn more about Financing Portal</a>
                        .
                    </Trans>
                </p>

            );
            break;
        case FinancingResultType.pending_approval:
            icon = <Lottie animationData={pendingAnimation} style={{width: 180}} />;
            title = <Trans>Pending Pre-approval Offer</Trans>;
            subtitle = (
                <p>
                    <Trans>
                        {`
                        Your ${<strong>non-identifiable data</strong>} will be shared with our 
                        lending partners ${<strong>securely</strong>} and you will be 
                        notified with the result in 2 business weeks. 
                        ${<a href="https://intercom.help/bukku/en/articles/8937350-introducing-financing-portal" target="_blank" rel="noreferrer">Learn more about Financing Portal</a>}
                        .`}
                    </Trans>
                </p>
            );
            break;
        case FinancingResultType.INSUFFICIENT_DATA:
            icon = <Lottie animationData={pendingDocAnimation} style={{width: 180}} />;
            title = <Trans>Insufficient Data</Trans>;
            subtitle = (
                <p>
                    <Trans>
                        Your business data in Bukku seems incomplete or not up-to-date.
                        You may still apply for a loan using the standard process with
                        more supporting documents by clicking on the &quot;Apply&quot; button.&nbsp;
                        <a href="https://intercom.help/bukku/en/articles/8937350-introducing-financing-portal" target="_blank" rel="noreferrer">Learn more about Financing Portal</a>
                        .
                    </Trans>
                </p>
            );
            break;
        case FinancingResultType.SCREENING_FAILED:
            icon = <Lottie animationData={pendingDocAnimation} style={{width: 180}} />;
            title = <Trans>Screening Failed</Trans>;
            subtitle = (
                <p>
                    <Trans>
                        Your business data in Bukku didn&apos;t pass the pre-approval screening.
                        You may still apply for a loan using the standard process with
                        more supporting documents by clicking on the &quot;Apply&quot; button.&nbsp;
                        <a href="https://intercom.help/bukku/en/articles/8937350-introducing-financing-portal" target="_blank" rel="noreferrer">Learn more about Financing Portal</a>
                        .
                    </Trans>
                </p>
            );
            break;
        case FinancingResultType.PREAPPROVED: {
            icon = <Lottie animationData={successAnimation} style={{width: 180}} />;
            title = <Trans>You&apos;ve Got Pre-approval Offer!</Trans>;
            subtitle = (
                <Trans>
                    Congratulations! You&apos;ve received a pre-approval loan offer
                    from our lending partners. You may proceed with loan application by
                    clicking on the &quot;Quick Apply&quot;
                    button and receive result in 2 business days.&nbsp;
                    <a href="https://intercom.help/bukku/en/articles/8937350-introducing-financing-portal" target="_blank" rel="noreferrer">Learn more about Financing Portal</a>
                    .
                </Trans>
            );
            break;
        }
        case FinancingResultType.NOT_QUALIFIED:
        default:
            icon = <Lottie animationData={failAnimation} style={{width: 180}} />;
            title = <Trans>Not Qualified :(</Trans>;
            subtitle = (
                <p>
                    <Trans>
                        We regret to inform you that your business doesn&apos;t
                        meet the criteria for financing, you may consider other financing options.&nbsp;
                        <a href="https://intercom.help/bukku/en/articles/8937350-introducing-financing-portal" target="_blank" rel="noreferrer">Learn more about Financing Portal</a>
                        .
                    </Trans>
                </p>
            );
            break;
    }

    return (
        <StyledModal
            // className="welcome-modal"
            width={520}
            // title={<Trans>Financing Portal</Trans>}
            open={isPendingApprovalModalVisible}
            destroyOnClose
            onCancel={onCancel}
            footer={null}
            // closable={true}
            // closeIcon={false}
            maskClosable={false}
        >
            <Result
                // status="success"
                icon={icon}
                title={title}
                subTitle={subtitle}
                extra={
                    <Button type="primary" key="console" onClick={onCancel}>
                        View Financing Portal
                    </Button>
                }
            />
        </StyledModal>
    );
}
